/**
 * Return whether an object has a property
 *
 * @param {object} object  The object
 * @param {string} property  The property name
 * @returns {boolean}  Whether the object has the property
 */
export const hasProperty = (object, property) => (object ? {}.hasOwnProperty.call(object, property) : false);
